
const directory = {
  path: 'directory',
  component: resolve => require(['../../../../../pages/modules/enterprise/directory'], resolve),
}

export default directory
